import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16, IcoTrash16 } from '@onefootprint/icons';
import { Button, Form, IconButton, Select } from '@onefootprint/ui';
import { Controller, useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import RequiredToggle from '@/components/required-toggle';
import { type OutputType, outputTypes } from '@/playbook-builder/utils/output-type';
import type { ExternalApiFormData } from '../../../../types';
type OnboardingVariablesProps = {
  canEdit: boolean;
};
const OnboardingVariables = t0 => {
  const $0 = _c(58);
  const {
    canEdit
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "externalApi.responseConfig.onboardingVariables"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    control,
    setValue
  } = useFormContext();
  let t2;
  if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "config.fieldExtractions"
    };
    $0[1] = t2;
  } else {
    t2 = $0[1];
  }
  const {
    fields: extractionFields,
    append,
    remove
  } = useFieldArray(t2);
  let t3;
  if ($0[2] !== control) {
    t3 = {
      control,
      name: "config.entireBody.enabled"
    };
    $0[2] = control;
    $0[3] = t3;
  } else {
    t3 = $0[3];
  }
  const entireBodyEnabled = useWatch(t3);
  let t4;
  if ($0[4] !== control) {
    t4 = {
      control,
      name: "config.fieldExtractions"
    };
    $0[4] = control;
    $0[5] = t4;
  } else {
    t4 = $0[5];
  }
  const extractions = useWatch(t4);
  let t5;
  if ($0[6] !== t) {
    t5 = outputTypes.map(value => ({
      value,
      label: t($ => $.outputType.options[value])
    }));
    $0[6] = t;
    $0[7] = t5;
  } else {
    t5 = $0[7];
  }
  const fieldTypeOptions = t5;
  let t6;
  if ($0[8] !== t) {
    t6 = t(_temp);
    $0[8] = t;
    $0[9] = t6;
  } else {
    t6 = $0[9];
  }
  let t7;
  if ($0[10] !== t6) {
    t7 = <div className="text-label-3 text-primary">{t6}</div>;
    $0[10] = t6;
    $0[11] = t7;
  } else {
    t7 = $0[11];
  }
  let t8;
  if ($0[12] !== t) {
    t8 = t(_temp2);
    $0[12] = t;
    $0[13] = t8;
  } else {
    t8 = $0[13];
  }
  const t9 = !canEdit;
  let t10;
  if ($0[14] !== t8 || $0[15] !== t9) {
    t10 = <Form.Toggle name="config.entireBody.enabled" label={t8} disabled={t9} />;
    $0[14] = t8;
    $0[15] = t9;
    $0[16] = t10;
  } else {
    t10 = $0[16];
  }
  let t11;
  if ($0[17] !== entireBodyEnabled || $0[18] !== t) {
    t11 = entireBodyEnabled && <div className="grid grid-cols-[1fr_auto] gap-3 items-center"><Form.Input name="config.entireBody.key" placeholder={t(_temp3)} addon="data." size="compact" /><Select size="compact" value="any" options={[{
        value: "any",
        label: t(_temp4)
      }]} disabled={true} onChange={_temp5} /></div>;
    $0[17] = entireBodyEnabled;
    $0[18] = t;
    $0[19] = t11;
  } else {
    t11 = $0[19];
  }
  let t12;
  if ($0[20] !== t10 || $0[21] !== t11) {
    t12 = <div className="flex flex-col gap-4">{t10}{t11}</div>;
    $0[20] = t10;
    $0[21] = t11;
    $0[22] = t12;
  } else {
    t12 = $0[22];
  }
  let t13;
  if ($0[23] !== t) {
    t13 = t(_temp6);
    $0[23] = t;
    $0[24] = t13;
  } else {
    t13 = $0[24];
  }
  let t14;
  if ($0[25] !== t13) {
    t14 = <p className="text-caption-2 text-tertiary">{t13}</p>;
    $0[25] = t13;
    $0[26] = t14;
  } else {
    t14 = $0[26];
  }
  let t15;
  if ($0[27] !== canEdit || $0[28] !== control || $0[29] !== extractionFields || $0[30] !== extractions || $0[31] !== fieldTypeOptions || $0[32] !== remove || $0[33] !== setValue || $0[34] !== t) {
    let t16;
    if ($0[36] !== canEdit || $0[37] !== control || $0[38] !== extractions || $0[39] !== fieldTypeOptions || $0[40] !== remove || $0[41] !== setValue || $0[42] !== t) {
      t16 = (field, index) => <div key={field.id} className="grid grid-cols-[1fr_auto_auto] gap-3 items-center md:grid-cols-[1fr_1fr_110px_auto_auto]"><div className="col-span-full grid grid-cols-2 gap-3 md:contents"><Form.Input name={`config.fieldExtractions.${index}.selector`} placeholder={t(_temp7)} addon="$." size="compact" disabled={!canEdit} /><Form.Input name={`config.fieldExtractions.${index}.key`} placeholder={t(_temp8)} addon="data." size="compact" disabled={!canEdit} /></div><Select size="compact" className="w-full md:w-[110px]" value={extractions?.[index]?.outputType ?? ""} placeholder={t(_temp9)} options={fieldTypeOptions} disabled={!canEdit} onChange={val => setValue(`config.fieldExtractions.${index}.outputType`, val as OutputType, {
          shouldDirty: true
        })} /><Controller control={control} name={`config.fieldExtractions.${index}.isRequired`} render={t17 => {
          const {
            field: toggleField
          } = t17;
          return <RequiredToggle id={field.id} value={toggleField.value ? "required" : "optional"} disabled={!canEdit} onOptionChange={val_0 => toggleField.onChange(val_0 === "required")} />;
        }} />{canEdit && <IconButton type="button" onClick={() => remove(index)} aria-label={t(_temp10)} icon={IcoTrash16} destructive={true} />}</div>;
      $0[36] = canEdit;
      $0[37] = control;
      $0[38] = extractions;
      $0[39] = fieldTypeOptions;
      $0[40] = remove;
      $0[41] = setValue;
      $0[42] = t;
      $0[43] = t16;
    } else {
      t16 = $0[43];
    }
    t15 = extractionFields.map(t16);
    $0[27] = canEdit;
    $0[28] = control;
    $0[29] = extractionFields;
    $0[30] = extractions;
    $0[31] = fieldTypeOptions;
    $0[32] = remove;
    $0[33] = setValue;
    $0[34] = t;
    $0[35] = t15;
  } else {
    t15 = $0[35];
  }
  let t16;
  if ($0[44] !== append || $0[45] !== canEdit || $0[46] !== t) {
    t16 = canEdit && <div><Button variant="secondary" onClick={() => append({
        key: "",
        selector: "",
        outputType: undefined,
        isRequired: false
      })} size="compact" prefixIcon={IcoPlusSmall16}>{t(_temp11)}</Button></div>;
    $0[44] = append;
    $0[45] = canEdit;
    $0[46] = t;
    $0[47] = t16;
  } else {
    t16 = $0[47];
  }
  let t17;
  if ($0[48] !== t15 || $0[49] !== t16) {
    t17 = <div className="flex flex-col gap-5 p-3 border border-tertiary rounded-md md:gap-3">{t15}{t16}</div>;
    $0[48] = t15;
    $0[49] = t16;
    $0[50] = t17;
  } else {
    t17 = $0[50];
  }
  let t18;
  if ($0[51] !== t14 || $0[52] !== t17) {
    t18 = <div className="flex flex-col gap-2 mt-2">{t14}{t17}</div>;
    $0[51] = t14;
    $0[52] = t17;
    $0[53] = t18;
  } else {
    t18 = $0[53];
  }
  let t19;
  if ($0[54] !== t12 || $0[55] !== t18 || $0[56] !== t7) {
    t19 = <div className="flex flex-col gap-3">{t7}{t12}{t18}</div>;
    $0[54] = t12;
    $0[55] = t18;
    $0[56] = t7;
    $0[57] = t19;
  } else {
    t19 = $0[57];
  }
  return t19;
};
export default OnboardingVariables;
function _temp($_0) {
  return $_0.fieldExtractions.title;
}
function _temp2($_1) {
  return $_1.entireBody.label;
}
function _temp3($_2) {
  return $_2.data.placeholder;
}
function _temp4($_3) {
  return $_3.outputType.options.any;
}
function _temp5() {}
function _temp6($_4) {
  return $_4.fieldExtractions.hint;
}
function _temp7($_5) {
  return $_5.jsonpath.placeholder;
}
function _temp8($_6) {
  return $_6.data.placeholder;
}
function _temp9($_7) {
  return $_7.outputType.placeholder;
}
function _temp10($_8) {
  return $_8.remove;
}
function _temp11($_9) {
  return $_9.add;
}